import { Controller } from "@hotwired/stimulus";

const EVERY_TIME = "every";

// "Every time" is an alternative to picking particular times, not an addition to them.
export default class extends Controller {
  static targets = ["select"];

  refine(event) {
    const chosen = event.target.dataset.value;
    const selected = [...this.selectTarget.selectedOptions].map((option) => option.value);
    const next =
      chosen === EVERY_TIME ? [EVERY_TIME] : selected.filter((value) => value !== EVERY_TIME);

    if (next.length !== selected.length) $(this.selectTarget).dropdown("set exactly", next);
  }
}
